import React from 'react';
import R from 'ramda';
import FontAwesome from 'react-fontawesome';

const Splits = ({ profile, dealWork, dealBlock }) => {
  if (dealWork && dealWork.work_ownership_info) {
    const user = R.find(R.propEq('user', profile.id))(
      dealWork.work_ownership_info
    );

    let percentage = null;
    if (user) {
      percentage = user.percentage;
    }

    if (dealBlock && dealBlock.changes) {
      const userSplit = dealBlock.changes.find(
        (change) => change.id === user.id
      );

      if (userSplit) {
        percentage = userSplit.percentage;
      }
    }

    if (percentage) {
      return (
        <p>
          <FontAwesome name="check" /> You own {percentage}% of this work.
        </p>
      );
    }
  }

  return null;
};

export default Splits;



// WEBPACK FOOTER //
// src/components/Deals/DealEditPages/Splits.js